import { useState } from 'react';
import { ColorChangeHandler, TwitterPicker } from 'react-color';
import OutsideClickHandler from 'react-outside-click-handler';

import './ColorPicker.scss';

const DEFAULT_COLOR = '#2E3949';

const pickerSampleColors = [
  '#EB144C',
  '#FF6900',
  '#FFC601',
  '#7BDCB5',
  '#00D084',
  '#8ED1FC',
  '#0693E3',
  '#2E3949',
  '#ABB8C3',
  '#FFFFFF',
];

const defaultProps = {
  color: DEFAULT_COLOR,
};

interface ColorPickerProps {
  color: string;
  onChange: (color: string) => void;
}

function ColorPicker({ color, onChange }: ColorPickerProps) {
  const [currentColor, setCurrentColor] = useState(color);
  const [isPickerVisible, setIsPickerVisible] = useState(false);

  const handleColorChange: ColorChangeHandler = (pickedColor, event) => {
    const shouldPickerVisible: boolean =
      event?.type !== 'click' && (event?.target.value as string).length < 6;

    setCurrentColor(pickedColor.hex);
    setIsPickerVisible(shouldPickerVisible);
    onChange(pickedColor.hex);
  };

  const togglePicker = () => {
    setIsPickerVisible(!isPickerVisible);
  };

  return (
    <div className="ColorPicker">
      <button className="ColorPicker__swatch" type="button" onClick={togglePicker}>
        <div className="ColorPicker__color" style={{ background: currentColor }} />
        {currentColor.toUpperCase()}
      </button>
      {isPickerVisible && (
        <div className="ColorPicker__picker-container">
          <OutsideClickHandler onOutsideClick={togglePicker}>
            <TwitterPicker
              color={currentColor}
              colors={pickerSampleColors}
              onChange={handleColorChange}
            />
          </OutsideClickHandler>
        </div>
      )}
    </div>
  );
}

ColorPicker.defaultProps = defaultProps;

export default ColorPicker;
